import { render, staticRenderFns } from "./MOH.vue?vue&type=template&id=5881382a"
import script from "./MOH.vue?vue&type=script&lang=ts"
export * from "./MOH.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports